import { hasUrlParam, setUrlParam } from 'wsm-srp-utilities';
import { MOBILE, DESKTOP } from '../global-constants';

export const isDealerDotComImage = (uri) => {
	const domainRegex =
		/(.*\/\/.*)?(pictures|images|static)(\.)([^.]+\.)?dealer\.com(.*)/;
	return domainRegex.test(uri);
};
// default widths
const DEFAULT_IMAGE_WIDTH_DESKTOP = 1024;
const DEFAULT_IMAGE_WIDTH_MOBILE = 414;

const defaultWidth = new Map([
	[DESKTOP, DEFAULT_IMAGE_WIDTH_DESKTOP],
	[MOBILE, DEFAULT_IMAGE_WIDTH_MOBILE]
]);

/**
 * Determines if Akamai Image Manager resize parameters should be added to an input Image URL.
 * Returns a string of the input URL with image resize parameters added.
 * @param {string} url - A URL string value
 */

const imageResizer = (uri, deviceType, flagRemoveResizer) => {
	if (!uri || !isDealerDotComImage(uri) || flagRemoveResizer) {
		return uri;
	}

	const IMAGE_WIDTH = defaultWidth.get(deviceType);

	const imageUrl = isDealerDotComImage(uri)
		? setUrlParam(uri, 'impolicy=downsize_bkpt&imdensity=1')
		: uri;

	let src = imageUrl;

	const isOptimized =
		hasUrlParam(imageUrl, 'impolicy') && !hasUrlParam(uri, 'impolicy');

	if (isOptimized) {
		src = setUrlParam(imageUrl, `w=${IMAGE_WIDTH}`);
	}

	return src;
};

export default imageResizer;
